// src/features/claim/routes.tsx
import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/app/routing/rootRoute';
import AuditLogPage from './pages/auditLog';
import { hasPermission } from '../../common/services/permissionService';
import { API_ENDPOINTS } from './api/apiEndpoints';
import { getPermissionKeyFromApi } from '../../common/components/fromatPermission';

export const auditLogRoute = createRoute({
 getParentRoute: () => rootRoute,
    path: '/auditLog',
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.AUDIT_LOG.SEARCH || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});


export const auditLogListRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/audit-log/',
    component: AuditLogPage,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.AUDIT_LOG.SEARCH || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});


export const auditLogRouteRoutes = [
    auditLogRoute,
    auditLogListRoute
];